<template>
  <div>
    <f7-block-title>{{ $t('campaign.cycles') }}</f7-block-title>
    <f7-block v-if="loading" class="loading-block">
      <f7-preloader />
    </f7-block>
    <f7-list v-else inset strong media-list>
      <f7-list-item
        v-for="cycle in cycles"
        :key="cycle.id"
        :title="$t('campaign.cycleNumber', { n: cycle.cycleNumber })"
        :subtitle="cycleStatus(cycle)"
        :after="cycle.expectedAmount ? `${fmtCfa(cycle.currentAmount ?? 0,cycle.currency)} / ${fmtCfa(cycle.expectedAmountCfa,cycle.currency)}` : ''"
      />
    </f7-list>
    <f7-block v-if="!loading && cycles.length === 0" class="empty-block">
      <p class="empty-text">{{ $t('campaign.noCycles') }}</p>
    </f7-block>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import client from '../../js/api/client.js'
import i18n from '../../js/i18n.js'

const { t } = i18n.global

const props = defineProps({ campaignId: { type: String, required: true } })

const cycles = ref([])
const loading = ref(true)

function fmtCfa(n, currency) { return `${Math.round(n ?? 0).toLocaleString('fr-FR')} ${currency}` }

function cycleStatus(cycle) {
  const statusKey = {
    PENDING: 'campaign.statusPending',
    ACTIVE: 'campaign.statusActive',
    COMPLETED: 'campaign.statusCompleted',
    COLLECTING: 'campaign.statusCollecting',
  }[cycle.status]
  return statusKey ? t(statusKey) : cycle.status || ''
}

onMounted(async () => {
  try {
    const { data } = await client.get(`/campaigns/${props.campaignId}/cycles`)
    cycles.value = data.content ?? data
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.loading-block { text-align: center; padding: 20px 0; }
.empty-block { text-align: center; }
.empty-text { font-size: 13px; color: var(--f7-on-surface-variant, #8e8e93); }
</style>
